import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

const KrShowCollapse = ({
  customClass = "",
  handleClick,
  status = true,
} = props) => {
  const { t } = useTranslation();
  const className = `krShowCollapse clickable ${customClass}}`;
  const title = status
    ? `${t("Hide key results")}`
    : `${t("Show key results")}`;
  const ariaTitle = status
    ? `${t("Hide key results below")}`
    : `${t("Show key results below")}`;
  const iconClass = status ? "icon icon-kr_collapse" : "icon icon-kr_expand";

  return (
    <button
      aria-expanded={status ? true : false}
      title={title}
      aria-label={ariaTitle}
      tabIndex="0"
      onClick={handleClick}
      className={className}
    >
      <span className={iconClass}></span>
    </button>
    )
}

export default memo(KrShowCollapse);